import { useState } from 'react';
import apiService from '../../services/apiService';

const RELATIONS = [
  { value: 'W', label: 'Wife' },
  { value: 'H', label: 'Husband' },
  { value: 'S', label: 'Son' },
  { value: 'D', label: 'Daughter' },
  { value: 'B', label: 'Brother' },
  { value: 'F', label: 'Father' },
  { value: 'M', label: 'Mother' },
];

const GENDER_FOR_RELATION = { W: 'female', H: 'male', S: 'male', D: 'female' };

export default function AddFamilyMemberForm({ memberId, onSaved, onCancel }) {
  const [form, setForm] = useState({ name: '', relation: '', gender: '', date_of_birth: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const set = (k, v) => {
    setForm(f => {
      const next = { ...f, [k]: v };
      if (k === 'relation') next.gender = GENDER_FOR_RELATION[v] || f.gender;
      return next;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.relation) { setError('Name and relation are required.'); return; }
    setSaving(true);
    setError(null);
    try {
      const payload = { ...form };
      if (!payload.gender) delete payload.gender;
      if (!payload.date_of_birth) delete payload.date_of_birth;
      await apiService.addFamilyMember(memberId, payload);
      onSaved();
    } catch (err) {
      setError(err.message || 'Failed to add family member.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="p-6 max-w-md">
      <h2 className="text-xl font-bold text-slate-800 mb-4">Add Family Member</h2>
      {error && <div className="mb-3 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">{error}</div>}
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">Full Name *</label>
          <input value={form.name} onChange={e => set('name', e.target.value)}
            placeholder="Enter full name" required maxLength={100}
            className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">Relationship *</label>
          <select value={form.relation} onChange={e => set('relation', e.target.value)}
            className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
            <option value="">Select relationship</option>
            {RELATIONS.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">Date of Birth</label>
          <input type="date" value={form.date_of_birth} onChange={e => set('date_of_birth', e.target.value)}
            className="w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
        </div>
        <div className="flex gap-3 pt-2">
          <button type="button" onClick={onCancel}
            className="flex-1 px-4 py-2 border border-slate-200 rounded-lg text-sm text-slate-600 hover:bg-slate-50 transition-colors">
            Cancel
          </button>
          <button type="submit" disabled={saving}
            className="flex-1 px-4 py-2 bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white rounded-lg text-sm font-medium transition-colors">
            {saving ? 'Saving…' : 'Add Member'}
          </button>
        </div>
      </form>
    </div>
  );
}
